import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Input, Row, Col, Table } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

import { loadAdmins, saveAdmin, updateAdmin, deactivateAdmin, clearMessage, dispatchErrorMessage } from '../../actions/index';
import AdminScreen from './AdminScreen';
import { MENUU_MASTER_ADMIN } from '../../utils/Constants';


class AdminsScreen extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modal: false,
			admin: null
		};

		this.toggleAdminScreen = this.toggleAdminScreen.bind(this);
	}

	componentWillMount() {
		this.props.loadAdmins();
	}

	toggleAdminScreen(selectedAdmin) {

		if (selectedAdmin !== undefined && selectedAdmin !== null) {
			this.setState({
				modal: !this.state.modal,
				admin: selectedAdmin
			});
		} else {
			this.setState({
				modal: !this.state.modal
			});
		}

	}

	saveAdmin(admin) {
		this.props.saveAdmin(admin);
	}

	updateAdmin(admin) {
		this.props.updateAdmin(admin);
	}

	deactivateAdmin(event) {
		var adminStatus = event.target.checked;
		var adminId = event.target.id;

		this.props.deactivateAdmin(adminStatus, adminId);
	}

	renderAdminsTableRow() {
		return this.props.admins.map(admin => {

			let adminIcon;
			if (admin.role === MENUU_MASTER_ADMIN) {
				adminIcon = (<MaterialIcon icon="verified_user" color="#000" size={20} />)
			}

			const adminStatus = admin.active;
			let disableAdminActions = (this.props.currentlyLoggedInUserRole === MENUU_MASTER_ADMIN) ? false : true;

			let element;

			const { editNameButton, inputCheckbox } = styles;

			if (this.props.currentlyLoggedInUserRole === MENUU_MASTER_ADMIN) {
				element = (
					<td>
						<Button color="link" onClick={() => this.toggleAdminScreen(admin)}
							style={editNameButton}>
							{admin.name}{adminIcon}
						</Button>
					</td>
				)
			} else {
				element = (<td>{admin.name}{adminIcon}</td>);
			}

			if (this.props.currentlyLoggedInUserRole === MENUU_MASTER_ADMIN && admin.id === Number(this.props.userId)) {
				disableAdminActions = true;
			}

			return (
				<tr key={admin.id}>
					{element}
					<td>{admin.phone}</td>
					<td>{admin.email}</td>
					<td>{admin.lastActiveTime}</td>
					<td>
						<Input
							type="checkbox"
							style={inputCheckbox}
							id={admin.id}
							name={admin.id}
							checked={adminStatus}
							disabled={disableAdminActions}
							onChange={this.deactivateAdmin.bind(this)}>
						</Input>
					</td>
				</tr>
			);
		});
	}


	render() {

		if (this.props.message !== undefined && this.props.message !== null && this.props.message.level == 1) {
			this.state.modal = false;
		}
		const { containerStyle, flexEnd, adminHeading, rowMarginBottom } = styles;

		const adminButtonDisplayStyle = (this.props.currentlyLoggedInUserRole === MENUU_MASTER_ADMIN) ? 'block' : 'none';

		return (
			<Container fluid style={containerStyle}>
				<Row style={rowMarginBottom}>
					<Col xs="auto" sm={1} style={adminHeading}>
						<div><MaterialIcon icon="group" color="#0288d1" /> &nbsp;{i18n.t('screens:restaurantsMainContainer.admins')}</div>
					</Col>
					<Col xs={11} style={flexEnd}>
						<Button style={{ display: adminButtonDisplayStyle }} color="primary" onClick={this.toggleAdminScreen}><MaterialIcon icon="group_add" color="#fff" />&nbsp;{i18n.t('screens:adminsScreen.addAdmin')}</Button>
					</Col>
				</Row>
				<Row>
					<Table responsive hover>
						<thead>
							<tr>
								<th>{i18n.t('common:form.name')}</th>
								<th>{i18n.t('common:form.phone')}</th>
								<th>{i18n.t('common:form.email')}</th>
								<th>{i18n.t('screens:adminsScreen.lastActiveTime')}</th>
								<th>{i18n.t('common:buttons.active')}</th>
							</tr>
						</thead>
						<tbody>
							{this.renderAdminsTableRow()}
						</tbody>
					</Table>
				</Row>
				<AdminScreen
					styles={styles}
					isOpen={this.state.modal}
					onToggle={this.toggleAdminScreen}
					admin={this.state.admin}
					onSave={this.saveAdmin.bind(this)}
					onUpdate={this.updateAdmin.bind(this)}
					dispatchMessage={this.props.dispatchErrorMessage} />
			</Container>
		);
	}
}

const mapStateToProps = state => {
	return {
		admins: state.admins,
		token: state.user.token,
		currentlyLoggedInUserRole: state.user.role,
		message: state.message,
		userId: state.user.id
	};
};

export default connect(mapStateToProps, { loadAdmins, saveAdmin, updateAdmin, deactivateAdmin, clearMessage, dispatchErrorMessage })(AdminsScreen);

let styles = {
	containerStyle: {
		width: '96%',
		marginTop: 20
	},
	flexEnd: {
		display: 'flex',
		justifyContent: 'flex-end',
		paddingRight: 0
	},
	adminHeading: {
		borderBottom: 1,
		borderBottomStyle: 'solid',
		borderBottomColor: 'blue',
		alignSelf: 'flex-end',
		borderColor: 'rgb(222, 226, 230)',
		paddingLeft: 0,
		color: '#0288d1'
	},
	rowMarginBottom: {
		marginBottom: 20
	},
	editNameButton: {
		height: '14px',
		padding: 0,
		margin: 0,
		verticalAlign: 'top'
	},
	inputCheckbox: {
		marginLeft: '20px',
		marginTop: '-4px'
	},
	alertStyle: {
		position: 'fixed',
		top: '70px',
		left: '0',
		right: '0',
		width: '400px',
		height: '50px',
		marginLeft: 'auto',
		marginRight: 'auto'
	},
	spaceBetween: {
		paddingLeft: 4
	}
}


// WEBPACK FOOTER //
// ./src/components/users/AdminsScreen.js